import { Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Insight } from 'modules/enps/store/models/AIInsights'

import QuestionHeadRow from './TableComponents/QuestionHeadRow'
import Row from './TableComponents/Row'

interface Props {
  insightsList: Insight[]
  title: string
}

const AiInsaightsTable = ({ insightsList, title }: Props) => {
  return (
    <Table>
      <Table.Head>
        <QuestionHeadRow label={title} />
      </Table.Head>
      <Table.Body>
        <Row
          label_1={i18n.t('enps.analytics.people_mentions.feelings')}
          label_2={i18n.t('enps.analytics.people_mentions.counts')}
          sub_header
        />
        {insightsList.map((d: Insight, i: number) => (
          <Row
            key={i}
            label_1={d.sentiment_description}
            label_2={d.mentions_count}
            sub_header={null}
          />
        ))}
      </Table.Body>
    </Table>
  )
}

export default AiInsaightsTable
